import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/gtag';

/**
 * Composant qui track les changements de page dans la SPA.
 * À placer à l'intérieur du <Router>.
 */
export function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}
